import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface BlogAuthGuardProps {
  children: React.ReactNode;
}

export const BlogAuthGuard: React.FC<BlogAuthGuardProps> = ({ children }) => {
  const { user, loading, isAdmin, isContentEditor } = useAuth();

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/sign-in" />;
  }

  // Check if user is an admin or content editor
  if (!isAdmin() && !isContentEditor()) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
};

export default BlogAuthGuard; 